export const PRIVACY_POLICY = "https://onecareer.co.jp/policy/";
export const COMPANY_SITE = "https://onecareer.co.jp/";
export const REQUEST_FORM = "https://onecareer.zendesk.com/hc/ja/requests/new";
